module.exports = __webpack_public_path__ + "static/img/核算通_标准版_封面.1c22ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/核算通_标准版_封面.jpg
// module id = fjOx
// module chunks = 1